import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import useResizeObserver from 'use-resize-observer';
import { pxInRem, uuid } from '../../../CodesThatsGottaGoSomewhereElse';
import { Colors } from './../../../ui';
import { withXmas } from './WithXmas';

const lightColors = [
    '#ffeb77',
    '#B974FF',
    '#F03B4D',
    '#40B8A8',
    '#47BFFE',
];

const Frame = styled.div`
    display: flex;
    justify-content: space-evenly;
    position: absolute;
    top: -.2rem;
    left: 0;
    right: 0;
    height: .2rem;
    z-index: 1;
    padding-top: .1rem;
    padding-left: 10rem;
    padding-right: 10rem;
`;

export const XmasLightsEditor = withXmas(() => {

    const { ref, width = 1, } = useResizeObserver<HTMLDivElement>();
    const [ticker, setTicker] = useState(0);

    const lights = useMemo(() => {
        lightColors.sort(() => Math.random() - 0.5);
        const count = Math.floor((pxInRem(width)) / 3);
        return (new Array(Math.max(1, count)).fill(0))
            .map((_, i) => ({ id: uuid(), type: (i % 2 + 1), color: lightColors[i % lightColors.length] }));
    }, [ticker, width]);

    return <Frame id="xmasLights" ref={ref}>
        {lights.map(l => <Bulb key={l.id} type={l.type} color={l.color} onClick={() => setTicker(x => x + 1)} />)}
    </Frame>;
});

const Bulb = ({ type, color, onClick }) => type === 1 ? (
    <svg style={{ flex: '0 0 auto', height: '1.25rem' }} viewBox="0 0 10 14" onClick={onClick}>
        <path fill={Colors.gray400} d="M5 5a2.5 2.5 0 112.5-2.5A2.5 2.5 0 015 5zm0-4a1.5 1.5 0 101.5 1.5A1.5 1.5 0 005 1z" />
        <circle cx="5" cy="9" r="5" fill={color} />
    </svg>
) : (
    <svg style={{ flex: '0 0 auto', height: '1.625rem' }} viewBox="0 0 10.2 20" onClick={onClick}>
        <path fill={Colors.gray400} d="M5.1 5a2.5 2.5 0 112.5-2.5A2.5 2.5 0 015.1 5zm0-4a1.5 1.5 0 101.5 1.5A1.5 1.5 0 005.1 1z" />
        <path fill={color} d="M5.1 4A5.1 5.1 0 000 9.1C0 10.6 1.5 20 5.1 20s5.1-9.4 5.1-10.9a5.1 5.1 0 00-5-5.1z" />
    </svg>
);
